module.exports = __webpack_public_path__ + "img/2.3d9e34c5.jpg";